module.exports = __webpack_public_path__ + "static/favicon_1-89eeb874d45e3b15b65380a380ccb425.png";